import { useState, useEffect, useCallback, useRef } from 'react';
import { getClientes } from '@spark/services';
import { notification } from '@spark/ui-components/utils/notification';

export const useClienteSelection = (show) => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({});
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(10);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const carregarClientes = useCallback(async () => {
    try {
      setLoading(true);

      const searchTerm = filtros?.CNPJ || filtros?.Nome || filtros?.Codigo || '';
      const params = {
        pagina: paginaAtual,
        quantidadePorPagina,
        page: paginaAtual,
        limit: quantidadePorPagina,
        ...(searchTerm ? { search: searchTerm } : {})
      };

      const response = await getClientes(params);
      const dados = response?.registros || response?.Registros || [];
      const total = response?.totalRegistros || response?.TotalRegistros || 0;

      setClientes(dados);
      setTotalRegistros(total);
    } catch (error) {
      console.error('Erro ao carregar clientes:', error);
      notification.error(
        error?.message || 'Não foi possível carregar os clientes',
        'Erro ao carregar clientes'
      );
      setClientes([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [filtros, paginaAtual, quantidadePorPagina]);

  const handleFiltrosChange = useCallback((novosFiltros) => {
    const sanitized = { ...novosFiltros };
    if (sanitized.CNPJ) {
      sanitized.CNPJ = String(sanitized.CNPJ).replace(/\D/g, '');
    }
    setFiltros(sanitized);
    setPaginaAtual(1);
  }, []);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  const prevShowRef = useRef(show);

  const resetFiltros = useCallback(() => {
    setFiltros({});
    setPaginaAtual(1);
    setQuantidadePorPagina(10);
  }, []);

  useEffect(() => {
    if (show) {
      carregarClientes();
    } else if (prevShowRef.current) {
      resetFiltros();
    }
    prevShowRef.current = show;
  }, [show, carregarClientes, resetFiltros]);

  return {
    clientes,
    loading,
    filtros,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
    resetFiltros,
  };
};
